import HttpClient from '@/common/boot/HttpClient';

const buscarModulos = async ({ commit }) => {

    commit('CARREGANDO_MODULOS', true);

    try {
        const response = await HttpClient.get('/ctrl-modulos');

        commit('SET_MODULOS', response.data.data);
        commit('SET_HAS_ACCESS', response.data.has_any_access);

        return response;

    } catch (error) {
        return error.response;
    } finally {
        commit('CARREGANDO_MODULOS', false);
    }
};


const selecionarModulo = async ({ commit, dispatch }, moduloId) => {
    try {
        const response = await HttpClient.post(`/ctrl-modulos/${moduloId}/selecionar`);
        
        const data = response.data.data;
        
        commit('SET_MODULO_ATIVO', data.modulo_id || moduloId);
        localStorage.setItem('moduloAtivo', data.modulo_id || moduloId);
        
        if (data.role_ativo) {
            commit('login/ATUALIZAR_ROLE_USUARIO', data.role_ativo, { root: true });
        }
        
        await dispatch('login/recarregarMenus', null, { root: true });
        await atualizarNotificacoesDoModulo(dispatch);

        return response;
    } catch (error) {
        return error.response;
    }
};

const trocarModulo = async ({ commit, dispatch }, moduloId) => {
    commit('SET_TROCANDO_MODULO', true);
    
    try {
        const response = await HttpClient.post(`/ctrl-modulos/${moduloId}/selecionar`);
        
        const data = response.data.data;
        
        commit('SET_MODULO_ATIVO', data.modulo_id || moduloId);
        localStorage.setItem('moduloAtivo', data.modulo_id || moduloId);
        
        if (data.role_ativo) {
            commit('login/ATUALIZAR_ROLE_USUARIO', data.role_ativo, { root: true });
        }
        
        await dispatch('login/recarregarMenus', null, { root: true });
        await atualizarNotificacoesDoModulo(dispatch);
        
        return response;
    } catch (error) {
        return error.response;
    } finally {
        commit('SET_TROCANDO_MODULO', false);
    }
};

const atualizarNotificacoesDoModulo = async (dispatch) => {
    await dispatch('pcoNotificacoes/limparEListarNotificacoesNaoLidas', null, { root: true });
};

const limparModuloAtivo = ({ commit }) => {
    commit('SET_MODULO_ATIVO', null);
    localStorage.removeItem('moduloAtivo');
};

// ─── CRUD admin ──────────────────────────────────────────────────────────────

const listarModulosAdmin = async ({ commit }, payload) => {
    commit('BUSCANDO', true);
    return await HttpClient.get('/ctrl-modulos', { params: payload }).then(response => {
        const data = response.data.data;
        commit('LISTAR_MODULOS_ADMIN', data.data || data);
        commit('ATUALIZAR_PAGINACAO', data.data ? data : null);
        return response;
    }).finally(() => {
        commit('BUSCANDO', false);
    });
};

const salvarModulo = async ({ commit, dispatch }, payload) => {
    commit('BUSCANDO', true);
    return await HttpClient.post('/ctrl-modulos', payload).then(response => {
        dispatch('listarModulosAdmin');
        return response;
    }).finally(() => {
        commit('BUSCANDO', false);
    });
};

const atualizarModulo = async ({ commit, dispatch }, payload) => {
    commit('BUSCANDO', true);
    return await HttpClient.put(`/ctrl-modulos/${payload.id}`, payload).then(response => {
        dispatch('listarModulosAdmin');
        return response;
    }).finally(() => {
        commit('BUSCANDO', false);
    });
};

const excluirModulos = async ({ dispatch }, payload) => {
    for (const linha of payload) {
        await HttpClient.delete(`/ctrl-modulos/${linha.id}`);
    }
    dispatch('listarModulosAdmin');
};

const restaurarModulo = async ({ commit, dispatch }, id) => {
    commit('BUSCANDO', true);
    return await HttpClient.post(`/ctrl-modulos/${id}/restaurar`).then(response => {
        dispatch('listarModulosAdmin');
        return response;
    }).finally(() => {
        commit('BUSCANDO', false);
    });
};

// ─── associação de usuários ──────────────────────────────────────────────────

const listarUsuariosParaModulo = async ({ commit }) => {
    commit('BUSCANDO', true);
    return await HttpClient.get('/usuarios').then(response => {
        commit('INSERIR_LISTA_USUARIOS', response.data);
        return response;
    }).finally(() => {
        commit('BUSCANDO', false);
    });
};

const recuperarModuloComUsuarios = async ({ commit }, id) => {
    commit('BUSCANDO', true);
    return await HttpClient.get(`/ctrl-modulos/${id}`).then(response => {
        commit('INSERIR_MODULO_SELECIONADO', response.data.data);
        return response;
    }).finally(() => {
        commit('BUSCANDO', false);
    });
};

const associarUsuarioAModulo = async ({ commit }, payload) => {
    commit('BUSCANDO', true);
    return await HttpClient.post(`/ctrl-modulos/${payload.moduloId}/associar-usuario`, payload).then(response => {
        return response;
    }).finally(() => {
        commit('BUSCANDO', false);
    });
};

const atualizarRoleUsuario = async ({ commit }, payload) => {
    commit('BUSCANDO', true);
    return await HttpClient.put(
        `/ctrl-modulos/${payload.moduloId}/atualizar-role-usuario/${payload.userId}`,
        payload
    ).then(response => {
        return response;
    }).finally(() => {
        commit('BUSCANDO', false);
    });
};

const desassociarUsuario = async ({ commit }, payload) => {
    commit('BUSCANDO', true);
    return await HttpClient.delete(
        `/ctrl-modulos/${payload.moduloId}/desassociar-usuario/${payload.userId}`
    ).then(response => {
        return response;
    }).finally(() => {
        commit('BUSCANDO', false);
    });
};

const recuperarMenusDoModulo = async ({ commit }, id) => {
    commit('BUSCANDO', true);
    return await HttpClient.get(`/ctrl-modulos/${id}/menus`).then(response => {
        commit('INSERIR_MODULO_SELECIONADO', response.data.data.modulo || {});
        return response;
    }).finally(() => {
        commit('BUSCANDO', false);
    });
};

const sincronizarMenusDoModulo = async ({ commit }, payload) => {
    commit('BUSCANDO', true);
    return await HttpClient.post(`/ctrl-modulos/${payload.moduloId}/menus/sincronizar`, {
        menus: payload.menus
    }).then(response => {
        commit('INSERIR_MODULO_SELECIONADO', response.data.data || {});
        return response;
    }).finally(() => {
        commit('BUSCANDO', false);
    });
};

const buscarModulosDoUsuarioLogado = async ({ commit }) => {

    commit('CARREGANDO_MODULOS', true);

    try {
        const response = await HttpClient.get('/ctrl-modulos-do-usuario');
        commit('SET_MODULOS', response.data.data);
        return response;

    } catch (error) {
        return error.response;
    } finally {
        commit('CARREGANDO_MODULOS', false);
    }
};

export {
    buscarModulos,
    selecionarModulo,
    trocarModulo,
    limparModuloAtivo,
    listarModulosAdmin,
    salvarModulo,
    atualizarModulo,
    excluirModulos,
    restaurarModulo,
    listarUsuariosParaModulo,
    recuperarModuloComUsuarios,
    associarUsuarioAModulo,
    atualizarRoleUsuario,
    desassociarUsuario,
    recuperarMenusDoModulo,
    sincronizarMenusDoModulo,
    buscarModulosDoUsuarioLogado
}